const deckTags = [
	{
		id: 1,
		name_en: 'Meta',
		name_de: 'Meta',
		name_fr: 'Meta',
		name_it: 'Meta',
		name_es: 'Meta',
		name_pt: 'Meta',
		slug: 'meta'
	},
	{
		id: 2,
		name_en: 'Rogue',
		name_de: 'Rogue',
		name_fr: 'Rogue',
		name_it: 'Rogue',
		name_es: 'Rogue',
		name_pt: 'Rogue',
		slug: 'rogue'
	},
	{
		id: 3,
		name_en: 'Casual',
		name_de: 'Casual',
		name_fr: 'Casual',
		name_it: 'Casual',
		name_es: 'Casual',
		name_pt: 'Casual',
		slug: 'casual'
	},
	{
		id: 4,
		name_en: 'Anime/Manga',
		name_de: 'Anime/Manga',
		name_fr: 'Anime/Manga',
		name_it: 'Anime/Manga',
		name_es: 'Anime/Manga',
		name_pt: 'Anime/Manga',
		slug: 'anime-manga'
	},
	{
		id: 5,
		name_en: 'Combo',
		name_de: 'Combo',
		name_fr: 'Combo',
		name_it: 'Combo',
		name_es: 'Combo',
		name_pt: 'Combo',
		slug: 'combo'
	},
	{
		id: 6,
		name_en: 'Midrange',
		name_de: 'Midrange',
		name_fr: 'Midrange',
		name_it: 'Midrange',
		name_es: 'Midrange',
		name_pt: 'Midrange',
		slug: 'midrange'
	},
	{
		id: 7,
		name_en: 'Control',
		name_de: 'Control',
		name_fr: 'Control',
		name_it: 'Control',
		name_es: 'Control',
		name_pt: 'Control',
		slug: 'control'
	},
	{
		id: 8,
		name_en: 'Stun',
		name_de: 'Stun',
		name_fr: 'Stun',
		name_it: 'Stun',
		name_es: 'Stun',
		name_pt: 'Stun',
		slug: 'stun'
	},
	{
		id: 9,
		name_en: 'Beatdown',
		name_de: 'Beatdown',
		name_fr: 'Beatdown',
		name_it: 'Beatdown',
		name_es: 'Beatdown',
		name_pt: 'Beatdown',
		slug: 'beatdown'
	},
	{
		id: 10,
		name_en: 'Burn',
		name_de: 'Burn',
		name_fr: 'Burn',
		name_it: 'Burn',
		name_es: 'Burn',
		name_pt: 'Burn',
		slug: 'burn'
	},
	{
		id: 11,
		name_en: 'Mill',
		name_de: 'Mill',
		name_fr: 'Mill',
		name_it: 'Mill',
		name_es: 'Mill',
		name_pt: 'Mill',
		slug: 'mill'
	},
	{
		id: 12,
		name_en: 'Handloop',
		name_de: 'Handloop',
		name_fr: 'Handloop',
		name_it: 'Handloop',
		name_es: 'Handloop',
		name_pt: 'Handloop',
		slug: 'handloop'
	},
	{
		id: 13,
		name_en: 'Budget',
		name_de: 'Budget',
		name_fr: 'Budget',
		name_it: 'Budget',
		name_es: 'Budget',
		name_pt: 'Budget',
		slug: 'budget'
	},
	{
		id: 270,
		name_en: 'Locals',
		name_de: 'Locals',
		name_fr: 'Locals',
		name_it: 'Locals',
		name_es: 'Locals',
		name_pt: 'Locals',
		slug: 'locals'
	},
	{
		id: 271,
		name_en: 'Regionals',
		name_de: 'Regionals',
		name_fr: 'Regionals',
		name_it: 'Regionals',
		name_es: 'Regionals',
		name_pt: 'Regionals',
		slug: 'regionals'
	},
	{
		id: 272,
		name_en: 'Tournament Report',
		name_de: 'Turnierbericht',
		name_fr: 'Compte rendu du tournoi',
		name_it: 'Resoconto del torneo',
		name_es: 'Informe del torneo',
		name_pt: 'Relatório do torneio',
		slug: 'tournament-report'
	},
	{
		id: 273,
		name_en: 'Tutorial',
		name_de: 'Tutorial',
		name_fr: 'Tutoriel',
		name_it: 'Tutorial',
		name_es: 'Tutorial',
		name_pt: 'Tutorial',
		slug: 'tutorial'
	},
	{
		id: 274,
		name_en: 'Combo Guide',
		name_de: 'Combo Guide',
		name_fr: 'Guide du combo',
		name_it: 'Guida del combo',
		name_es: 'Guía del combo',
		name_pt: 'Guia do combo',
		slug: 'combo-guide'
	},
	{
		id: 275,
		name_en: 'Going First',
		name_de: 'Going First',
		name_fr: 'Going First',
		name_it: 'Going First',
		name_es: 'Going First',
		name_pt: 'Going First',
		slug: 'going-first'
	},
	{
		id: 276,
		name_en: 'Going Second',
		name_de: 'Going Second',
		name_fr: 'Going Second',
		name_it: 'Going Second',
		name_es: 'Going Second',
		name_pt: 'Going Second',
		slug: 'going-second'
	},
	{
		id: 277,
		name_en: 'OTK',
		name_de: 'OTK',
		name_fr: 'OTK',
		name_it: 'OTK',
		name_es: 'OTK',
		name_pt: 'OTK',
		slug: 'otk'
	},
	{
		id: 278,
		name_en: 'WIP',
		name_de: 'WIP',
		name_fr: 'WIP',
		name_it: 'WIP',
		name_es: 'WIP',
		name_pt: 'WIP',
		slug: 'wip'
	},
	{
		id: 281,
		name_en: 'Graveyard',
		name_de: 'Friedhof',
		name_fr: 'Cimetière',
		name_it: 'Cimitero',
		name_es: 'Cementerio',
		name_pt: 'Cemitério',
		slug: 'graveyard'
	},
	{
		id: 282,
		name_en: 'Banish',
		name_de: 'Banish',
		name_fr: 'Banish',
		name_it: 'Banish',
		name_es: 'Banish',
		name_pt: 'Banish',
		slug: 'banish'
	},
	{
		id: 283,
		name_en: 'Anti Meta',
		name_de: 'Anti Meta',
		name_fr: 'Anti Meta',
		name_it: 'Anti Meta',
		name_es: 'Anti Meta',
		name_pt: 'Anti Meta',
		slug: 'anti-meta'
	},
	{
		id: 284,
		name_en: 'Feedback appreciated',
		name_de: 'Feedback erwünscht',
		name_fr: 'Feedback apprécié',
		name_it: 'Feedback apprezzato',
		name_es: 'Feedback apreciado',
		name_pt: 'Feedback apreciado',
		slug: 'feedback-appreciated'
	}
]

export const deckTagGroups = [
	{
		name: 'general.tagGroupGeneral',
		members: [273, 274, 284, 272, 270, 271, 278]
	},
	{
		name: 'general.tagGroupPower',
		members: [1, 2, 3, 13, 4]
	},
	{
		name: 'general.tagGroupStyle',
		members: [283, 282, 9, 10, 5, 7, 281, 275, 276, 12, 6, 11, 277, 8]
	}
]

export default deckTags
